<template>
<div class="wrapper">
  <HeaderNav title="配置域名授权" v-if="!isMobile"></HeaderNav>
  <div class="container">
    <p>是否确认配置域名授权?</p>
    <div class="footer-btns">
      <div class="submit-btn" @click="setAuth">确认授权</div>
      <router-link :to="{path: '/filing?shopCode='+shopCode}" class="jump-btn">跳过</router-link>
    </div>
  </div>
</div>
</template>

 
<script>
import { manageApplyPlugin} from '@/api/register';
export default {
  data () {
    return {
      isMobile: false,
      docHt: document.body.offsetHeight > 0 ? document.body.offsetHeight : document.body.clientHeight,
      shopCode: null,
    }
  },
  created() {
    if(this.$route.query){
      this.shopCode = this.$route.query.shopCode;
    }
    this.mobileTerminal((data) => {
      this.isMobile = data
    })
  },
  methods: {
    setAuth(){
      manageApplyPlugin({shopCode:this.shopCode},this.shopCode).then(res=>{
        if(res.code === 200) {
          setTimeout(() => {
            this.$router.push({
              path: '/filing?shopCode=' + this.shopCode
            })
          }, 1500)
        } else {
          this.Toast(res.msg);
        }
      })
    },
  }
}
</script>
 
<style lang="scss" scoped>
.container{
  p{
    line-height: 24px;
    font-size: 14px;
    color: #222;
    text-align: center;
    font-weight: bold;
    margin: 100px 20px 40px;
    /*
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    */
  }
}
.footer-btns{
  display: flex;
  align-items: center;
  justify-content: center;
}
@media screen and (max-width:750px){
  .submit-btn{
    width: 8.1rem;
    height: 2.2rem;
    line-height: 2.15rem;
    background: #47B6C7;
    border-radius: .5rem;
    font-size: .8rem;
    color: #fff;
    text-align: center;
    margin: 0;
    // margin: 2.1rem auto 1.5rem;
  }
  .jump-btn{
    line-height: 1.4;
    font-size: .8rem;
    color: #47B6C7;
    text-align: center;
    display: block;
    margin-left: .6rem;
  }
}
@media screen and (min-width:750px){
  .submit-btn{
    width: 162px;
    height: 44px;
    line-height: 43px;
    background: #47B6C7;
    border-radius: 10px;
    font-size: 16px;
    color: #fff;
    text-align: center;
    margin: 0;
    // margin: 42px auto 30px;
  }
  .jump-btn{
    line-height: 1.4;
    font-size: 16px;
    color: #47B6C7;
    text-align: center;
    display: block;
    margin-left: 12px;
  }
  .footer{
    position: fixed;
    bottom: auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/set-auth.vue